import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { DTPage } from '@signature-it/ngx-generic/models';
import { PageNotificationService, GadgetApiService} from '@signature-it/ngx-generic/services';


@Component({
    selector: 'card-gadget',
    templateUrl: './card.gadget.html',
    styleUrls: ['./card.gadget.scss'],
    standalone: false
})
export class CardGadget implements OnInit {
  @Input() title: string;
  @Input() btnText: string;
  @Input() btnLink: string;
  @Input() key: string;
  @Input() url: string;
  @Input() data: string;
  cardNum: number;
  cardText: string;
  showGadget: boolean = false;

  constructor(
              protected notifySvc: PageNotificationService,
              public router: Router,
              protected gadgetApiSvc: GadgetApiService) {

  }

  ngOnInit() {
      this.getData();
  }

  getData() {
      this.gadgetApiSvc.getCardData(this.key, this.url)
        .subscribe(
            res => {
              if (res) {
                  this.showGadget = true;
                this.cardNum = res['num'];
                this.cardText = res['text'];
              } else {
                this.notifySvc.set('Some Error Occurred').show();
              }
            },
            error => {
              this.notifySvc.set(error).show();
            }
        );
      // let dtPage = new DTPage({size: 1});
      // this.ordersSvc.getPendingApprovalOrders({
      //   'dtPage': dtPage,
      // }).subscribe((DTPagedData: any) => {
      //         if(DTPagedData['page']) {
      //             this.cardNum  = +DTPagedData['page']['totalElements'];
      //               this.cardText = "Orders";
      //         }
      //     },
      //     err => {
      //       this.notifySvc.set(err).show();
      //     }
      // );
  }

  onBtnClick() {
      this.router.navigate([this.btnLink]);
  }

}
